// extracted by mini-css-extract-plugin
module.exports = {"cart-icon":"cart-icon_cart-icon__2VC8n","shopping-icon":"cart-icon_shopping-icon__3tQzo","item-count":"cart-icon_item-count__2ANZn"};